import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-eligibility-check",
    templateUrl: "./eligibility-check.component.html",
    standalone: false
})
export class EligibilityCheckComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
